import gsap from 'gsap'
import { module as BaseModule } from 'modujs'

const XL = window.matchMedia('(min-width: 1280px)')

export default class extends BaseModule {
  init() {
    this.video = this.el.matches('video') ? this.el : this.el.querySelector('video')
    this.breakpoint = this.el.dataset.heroBreakpoint
    this.loaded = false

    this.onBreakpointChange = this.onBreakpointChange.bind(this)
    this.fadeIn = this.fadeIn.bind(this)

    if (this.isActiveBreakpoint()) {
      this.loadVideo()
    }

    XL.addEventListener('change', this.onBreakpointChange)
  }

  isActiveBreakpoint() {
    const isDesktop = XL.matches
    return (
      (this.breakpoint === 'desktop' && isDesktop) ||
      (this.breakpoint === 'mobile' && !isDesktop)
    )
  }

  loadVideo() {
    if (!this.video || this.loaded) return

    const source = this.video.querySelector('source[data-src]')
    if (!source) return

    this.removeEarlyPreload()

    source.src = source.dataset.src
    this.video.preload = 'auto'
    this.video.load()
    this.video.play().catch(() => {})
    this.video.addEventListener('playing', this.fadeIn, { once: true })
    this.loaded = true
  }

  removeEarlyPreload() {
    const early = document.querySelector(`[data-hero-early-preload="${this.breakpoint}"]`)
    if (!early) return

    early.pause()
    early.removeAttribute('src')
    early.load()
    early.remove()
  }

  unloadVideo() {
    if (!this.video || !this.loaded) return

    this.video.pause()
    this.video.removeEventListener('playing', this.fadeIn)

    const source = this.video.querySelector('source')
    if (source) {
      source.removeAttribute('src')
    }

    this.video.load()
    gsap.set(this.video, { opacity: 0 })
    this.loaded = false
  }

  fadeIn() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      gsap.set(this.video, { opacity: 1 })
      return
    }

    gsap.to(this.video, {
      opacity: 1,
      duration: 1,
      ease: 'power2.out',
    })
  }

  onBreakpointChange() {
    if (this.isActiveBreakpoint()) {
      this.loadVideo()
    } else {
      this.unloadVideo()
    }
  }

  destroy() {
    XL.removeEventListener('change', this.onBreakpointChange)
    this.unloadVideo()
  }
}
